import React, { useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { Box, Divider, Tab, Tabs, Typography } from '@mui/material'

import CatalogDiscount from './components/CatalogDiscount'
import Commercials from './components/Commercials'
import { UploadTdpDocuments } from './components/Documents'
import Rebate from './components/Rebate'
import TDPDetails from './components/TDPDetails'

export interface TenantDetails {
  tenantId: string
  name: string
  currency: string
}
function TDPRegistration() {
  const location = useLocation()
  const navigate = useNavigate()

  const currentTab = location.hash || '#details'

  const handleTabChange = (_, newValue) => {
    navigate(newValue)
  }

  const handleSaveSuccess = (tabName: string) => {
    handleTabChange(null, tabName)
  }

  const [tenantDetails, setTenantDetails] = useState<TenantDetails>({
    tenantId: '',
    name: '',
    currency: ''
  })

  return (
    <Box>
      <Box
        sx={{
          background: '#000869',
          padding: '15px',
          borderRadius: '10px'
        }}
      >
        <Typography variant='h4' color='#fff'>
          TDP Registration
        </Typography>
      </Box>

      <Box sx={{ width: '100%', mt: '30px' }}>
        <Tabs
          value={currentTab}
          onChange={handleTabChange}
          aria-label='hash navigation tabs'
          sx={{ width: '100%' }}
        >
          <Tab label='TDP Details' value='#details' sx={{ width: '20%' }} />
          <Tab
            label='Catalog & Discount'
            value='#catalogDiscount'
            sx={{ width: '20%' }}
          />
          <Tab label='Commercials' value='#commercials' sx={{ width: '20%' }} />
          <Tab label='Rebate' value='#rebate' sx={{ width: '20%' }} />
          <Tab label='Documents' value='#documents' sx={{ width: '20%' }} />
        </Tabs>
      </Box>

      <Divider />

      <Box sx={{ width: '100%', mt: '30px' }}>
        {currentTab == '#details' && (
          <TDPDetails
            onSaveSuccess={handleSaveSuccess}
            setTenantDetails={setTenantDetails}
          />
        )}
        {currentTab == '#catalogDiscount' && (
          <CatalogDiscount
            tenantDetails={tenantDetails}
            onSaveSuccess={handleSaveSuccess}
          />
        )}
        {currentTab == '#commercials' && (
          <Commercials
            tenantDetails={tenantDetails}
            onSaveSuccess={handleSaveSuccess}
          />
        )}
        {currentTab == '#rebate' && (
          <Rebate
            tenantDetails={tenantDetails}
            onSaveSuccess={handleSaveSuccess}
          />
        )}
        {currentTab == '#documents' && (
          <UploadTdpDocuments
            tenantDetails={tenantDetails}
            // onSaveSuccess={handleSaveSuccess}
          />
        )}
      </Box>
    </Box>
  )
}

export default TDPRegistration
